import React from "react";

const Stepper = ({ stepsCount = 12, currentStep = 0, onComplete }) => {
  React.useEffect(() => {
    if (currentStep >= stepsCount && onComplete) {
      onComplete();
    }
  }, [currentStep, stepsCount, onComplete]);

  return (
    <div className="w-full">
      <div className="flex items-center justify-between w-full">
        {Array.from({ length: stepsCount }, (_, i) => (
          <div className="flex-1 flex items-center relative" key={i}>
            <div
              className={`flex-shrink-0 w-6 h-6 sm:w-5 sm:h-5 rounded-full border-2 text-xs sm:text-sm flex items-center justify-center font-semibold
              ${
                i < currentStep
                  ? "bg-[#009951] border-[#009951] text-white"
                  : i === currentStep
                  ? "border-border text-muted-foreground"
                  : "border-border text-muted-foreground"
              }`}
            >
              {i < currentStep ? "✓" : ''}
            </div>

            {i !== stepsCount-1 && (
              <div
                className={`h-0.5 flex-1 bg-border absolute left-[20px] top-1/2 w-[calc(100%-20px)]`}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Stepper;
